import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PageLayout from '../../components/new-layout/PageLayout';
import * as routing from '../../constants/Routing';
import { useRetrieveActiveProject } from '../../hooks/project/useRetrieveActiveProject';
import { useCustomParams } from '../../hooks/useCustomParams';
import eventsPanel, { PageViewPages } from '../../services/events';
import { PlanDetails } from './plan-details';
import { PlannerPlans } from './planner-plans';

export const Planner = () => {
  const { value: projectId } = useCustomParams({ param: `projectId` });
  const { data: activeProject } = useRetrieveActiveProject();

  useEffect(() => {
    eventsPanel.pageView(PageViewPages.plans);
  }, []);

  if (!activeProject) {
    return null;
  }

  return (
    <Routes>
      <Route path="/plan/:planId/*" element={<PlanDetails />} />
      <Route
        path="*"
        element={
          <PageLayout style={{ overflow: `hidden` }}>
            <Grid
              container
              direction="column"
              wrap="nowrap"
              style={{
                zIndex: 1,
                height: `100%`,
                width: `100%`,
                backgroundColor: RoutalPalette.neutral02n,
              }}
            >
              <Routes>
                <Route
                  index
                  element={<Navigate to={routing.PLANNER.PLANS.replace(`:projectId`, projectId ?? activeProject.id)} />}
                />

                <Route path="/plans" element={<PlannerPlans />} />

                <Route
                  path="*"
                  element={<Navigate to={routing.PLANNER.PLANS.replace(`:projectId`, projectId ?? activeProject.id)} />}
                />
              </Routes>
            </Grid>
          </PageLayout>
        }
      />
    </Routes>
  );
};
